import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import Heading from '../../../../../common/Heading';
import {
  TextInput,
  TextAreaInput,
  AddressInputFields,
  FileUploadInput,
} from '../../../../../common/FormFields';
import formStyles from '../../../../../styles/forms.module.scss';
import s from './StepSomeInformation.module.scss';
import { ALLOWED_FILE_EXTENSIONS } from '../../../../../common/FormFields/shared/fileUpload';

type InformationField = 'company' | 'notes' | 'file';

const fieldName = (field: InformationField) => `information.${field}`;

function StepSomeInformation() {
  return (
    <section className={s.stepSomeInformation}>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.StepSomeInformation.title" />
      </Heading>
      <p className={s.introText}>
        <FormattedMessage id="offerWizard.StepSomeInformation.introText" />
      </p>
      <div className={formStyles.formFields}>
        <fieldset>
          <legend className={s.legend}>
            <FormattedMessage id="offerWizard.StepSomeInformation.address" />
          </legend>
          <Field
            name={fieldName('company')}
            labelMsg="offerWizard.StepSomeInformation.company.label"
            component={TextInput}
            fullWidth
            labelClass={formStyles.fullWidthField}
            autoComplete="organization"
            required
          />
          <div className={s.address}>
            <AddressInputFields namePrefix="information" isRequired />
          </div>
          <div className={formStyles.fullWidthField}>
            <Field
              name={fieldName('notes')}
              labelMsg="offerWizard.StepSomeInformation.notes.label"
              component={TextAreaInput}
              labelHTML={
                <>
                  <legend className={s.legend}>
                    <FormattedMessage id="offerWizard.StepSomeInformation.additionalInformations" />
                  </legend>
                  <FormattedMessage id="offerWizard.StepSomeInformation.additionalInformations.text" />
                </>
              }
            />
          </div>
          <div className={formStyles.inputPairSingle}>
            <Field
              name={fieldName('file')}
              component={FileUploadInput}
              allowedExtensions={ALLOWED_FILE_EXTENSIONS}
            />
          </div>
        </fieldset>
      </div>
    </section>
  );
}

export default StepSomeInformation;
